export enum RedemptionStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum RedemptionType {
  PARCEL = 'parcel',
  CREMATION = 'cremation',
  FUNERAL = 'funeral',
  FUNERAL_PARCEL = 'funeral_parcel',
  FUNERAL_CREMATION = 'funeral_cremation',
}

export interface CreateRedemptionRequest {
  type: RedemptionType;
  contractId: string;
  subscriptionId: string;
  parcelId?: string | null;
  priceDifference?: number;
  ids?: string[];
}

export interface CompleteRedemptionRequest {
  contractNumber: string
  offeringId: string
  userId: string
  priceDifference: number
  endDate?: Date
  deathDate?: Date
}

export interface Redemption {
	id: string;
	type: RedemptionType;
	status: RedemptionStatus;
	contractId: string;
	redeemedContractId: string | null;
	parcelId: string;
	priceDifference: number;
	ids: string [];
	sourceContractNumber?: string;
	sourceUserId?: string;
	sourceUserEmail?: string;
	redeemedContractNumber?: string;
	redeemedUserEmail?: string;
	createdBy: string;
	updatedBy: string | null;
  createdAt: Date
  updatedAt: Date
}

export interface RedemptionWithDetails extends Redemption {
  sourceContract?: {
    id: string
    contractNumber: string
    userId: string
    userName?: string
    offeringName?: string
    amount: number
    status: string
  } | null
  redeemedContract?: {
    id: string
    contractNumber: string
    userId: string
    userName?: string
    offeringName?: string
    amount: number
    status: string
  } | null
}

export interface RedemptionFilters {
  userId?: string
  contractId?: string
  status?: RedemptionStatus
  type?: RedemptionType
  page?: number
  limit?: number
  search?: string
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
}

export const formatRedemptionStatus = (status: RedemptionStatus): string => {
  const statuses: Record<RedemptionStatus, string> = {
    [RedemptionStatus.Pending]: 'Pendiente',
    [RedemptionStatus.Approved]: 'Aprobado',
    [RedemptionStatus.Rejected]: 'Rechazado',
  }
  return statuses[status] || status
}

export const getRedemptionStatusColor = (status: RedemptionStatus): string => {
  switch (status) {
    case RedemptionStatus.Pending:
      return 'bg-yellow-100 text-yellow-800'
    case RedemptionStatus.Approved:
      return 'bg-green-100 text-green-800'
    case RedemptionStatus.Rejected:
      return 'bg-red-100 text-red-800'
    default:
      return 'bg-gray-100 text-gray-800'
  }
}

export const formatRedemptionType = (type: RedemptionType): string => {
  const types: Record<RedemptionType, string> = {
    [RedemptionType.PARCEL]: 'Redención de parcela',
    [RedemptionType.CREMATION]: 'Redención de cremación',
    [RedemptionType.FUNERAL]: 'Redención de sepelio',
    [RedemptionType.FUNERAL_PARCEL]: 'Redención combinada: sepelio + parcela',
    [RedemptionType.FUNERAL_CREMATION]: 'Redención combinada: sepelio + cremación',
  }
  return types[type] || type
}

export const formatRedemptionStatusForBadge = (status: RedemptionStatus): string => {
  const statuses: Record<RedemptionStatus, string> = {
    [RedemptionStatus.Pending]: 'Pendiente',
    [RedemptionStatus.Approved]: 'Aprobado',
    [RedemptionStatus.Rejected]: 'Rechazado',
  }
  return statuses[status] || status
}

export const formatRedemptionStatusColor = (status: RedemptionStatus): string => {
  const statuses: Record<RedemptionStatus, string> = {
    [RedemptionStatus.Pending]: 'bg-blue-100 border-blue-100',
    [RedemptionStatus.Approved]: 'bg-green-100 border-green-100',
    [RedemptionStatus.Rejected]: 'bg-red-100 border-red-100',
  }
  return statuses[status] || status
}


export const formatPriceDifference = (value: number): string => {
  const formatted = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
  }).format(Math.abs(value))

  if (value > 0) return `Cliente debe: ${formatted}`
  if (value < 0) return `Crédito para cliente: ${formatted}`
  return 'Sin diferencias de precio'
}
